var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-level jc-center hp-10" }, [
    _c(
      "div",
      { staticClass: "flex-column ai-center" },
      [
        _c("img", {
          staticClass: "  ",
          attrs: { src: "/ressources/logged/img/onboarding/email/cup.png" }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "mb-0 mt-5" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Tout est bon !")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-4 mt-3 w-5 acenter fs-3" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Vous pouvez désormais utiliser l’ensemble des fonctionnalités %(provider)s directement depuis Sellsy",
                  { provider: _vm.nameProvider }
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__("common.actions.continue"),
            type: "primary"
          },
          on: {
            click: function($event) {
              return _vm.goToContext()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }